import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconEnterLeftOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m18.03 17.07-1.06 1.06L10.84 12l6.13-6.13 1.06 1.06-4.319 4.32H24v1.5H13.71zM3 3h7v18H3zm19.5 19.5v-3.75H24v3.75a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 0 22.5v-21A1.5 1.5 0 0 1 1.5 0h21A1.5 1.5 0 0 1 24 1.5v3.75h-1.5V1.5h-21v21z" /></svg>
);
